<script setup lang="ts">
import {useRoute} from 'vue-router';
import {useScriptTag} from '@vueuse/core';

const route = useRoute();
const appVersion = await useAppVersion();

const nuxtApp = useNuxtApp();
nuxtApp.hook('page:finish', () => {
  window.scrollTo(0, 0);
});

const {load} = useScriptTag(`${useCdnUrl()}/assets/js/feeder.js`, () => {}, {
  manual: true,
});

const {load: loadConfig} = useScriptTag(`${useCdnUrl()}/assets/js/feeder-config.js`, () => {}, {
  manual: true,
});

const {isConsent, sendScreenView} = useAnalytics();
const cookieAccepted = useCookie(`${useRuntimeConfig().public.appName}_cookieAccepted`);
const consent = useCookie(`${useRuntimeConfig().public.appName}_cookieConsent`);
const appMounted = useState('appMounted', () => false);

onMounted(async () => {
  const {getSessionId} = useUtils();
  const analyticsOptions = {
    apiUrl: useRuntimeConfig().public.zenAnalytics,
    appId: useRuntimeConfig().public.appId,
    userId: getSessionId(),
    tenant: useRuntimeConfig().public.appTenant,
    appName: useRuntimeConfig().public.appName,
    useZenAnalytics: useRuntimeConfig().public.useZenAnalytics,
    useGtag: useRuntimeConfig().public.analyticsEnabled,
    gtag: {
      enabled: useRuntimeConfig().public.useGtag,
      config: {
        id: useRuntimeConfig().public.gaTagIds,
      },
    },
    appReleaseNumber: appVersion.version,
    useageType: 'user',
    eventId: '',
    useZenClientHeader: false,
  };

  useAnalytics(analyticsOptions);

  isConsent.value = consent.value === 'true';

  if (isConsent.value) {
    await loadConfig();
    load();
  }

  appMounted.value = true;
});

async function onCookieConsent(hasConsented: boolean) {
  isConsent.value = hasConsented;
  consent.value = hasConsented ? 'true' : 'false';
  cookieAccepted.value = hasConsented ? 'true' : 'false';
  sendScreenView({type: 'click', target: 'gdpr-accepted'});
  await loadConfig();
  load();
}

onUnmounted(() => {
  const {sendScreenView} = useAnalytics();
  sendScreenView({
    type: 'UnloadEvent',
    target: 'index',
  });
});
</script>

<template>
  <div class="app-wrapper">
    <TheNavBar v-if="route.path !== '/creative-services'" />
    <NuxtPage />
    <TheFooter />
    <Cookies v-if="cookieAccepted === undefined" @cookie-consent="onCookieConsent" />
  </div>
</template>
